
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Bookpunetobhimashankarcab() {



    const cardData =
    {
        keyword: 'Pune to Bhimashankar Taxi Services',
        heading: 'S9 Travels: Pune to Bhimashankar Taxi Services',
        headingDescription: 'S9 Travels offers reliable, comfortable, and affordable taxi services from Pune to Bhimashankar. Whether you are traveling for a spiritual visit or a nature retreat, our well-maintained fleet and professional drivers ensure a smooth and hassle-free journey. Bhimashankar is approximately 110 km from Pune, and the journey takes around 3 to 4 hours by road. Enjoy a safe, comfortable ride with our top-notch amenities and customer-centric service.',

        top: 'Top Places to Visit in Bhimashankar with S9 Travels',

"topPlaces": [
    {
        "title": "Bhimashankar Temple",
        "description": "One of the 12 Jyotirlingas of Lord Shiva, Bhimashankar Temple is a highly revered pilgrimage site. Nestled in the Sahyadri Hills, the temple's ancient Nagara-style architecture and spiritual ambiance attract devotees from all over India. The temple is surrounded by dense forests, adding to its mystical charm."
    },
    {
        "title": "Bhimashankar Wildlife Sanctuary",
        "description": "The Bhimashankar Wildlife Sanctuary is a paradise for nature lovers and wildlife enthusiasts. Spread across the Western Ghats, the sanctuary is home to diverse flora and fauna, including the rare Indian Giant Squirrel. Visitors can explore nature trails, birdwatch, and enjoy the serenity of the lush greenery."
    },
    {
        "title": "Gupt Bhimashankar",
        "description": "A lesser-known but spiritually significant site, Gupt Bhimashankar is believed to be the original place where Lord Shiva manifested as a Jyotirlinga. Located deep within the forest, this hidden shrine offers a tranquil and meditative atmosphere. The journey to Gupt Bhimashankar involves a scenic trek, making it a rewarding experience for adventure seekers and devotees alike."
    },
    {
        "title": "Hanuman Lake",
        "description": "Hanuman Lake is a peaceful spot surrounded by dense forests and hills. Named after Lord Hanuman, the lake is a great place to relax and enjoy nature. The calm waters and the lush green surroundings make it an ideal destination for picnics and nature walks. Visitors often spot various bird species, adding to the charm of this hidden gem."
    },
    {
        "title": "Nagphani (Duke’s Nose)",
        "description": "Nagphani, also known as Duke’s Nose, is a popular trekking destination near Bhimashankar. The viewpoint offers breathtaking panoramic views of the Sahyadri mountain range. Adventure enthusiasts visit Nagphani for trekking and rock climbing. The cool breeze and scenic landscapes make the trek an unforgettable experience."
    },
    {
        "title": "Ahupe Ghat",
        "description": "Ahupe Ghat is a stunning mountain pass that connects the Deccan Plateau with the Konkan region. It is known for its mesmerizing views of valleys, waterfalls, and lush greenery. Trekkers and nature lovers often visit Ahupe Ghat to experience the beauty of the Western Ghats. The ghat is also home to a small tribal village, offering a glimpse into the traditional lifestyle of the locals."
    },
    {
        "title": "Bombay Point",
        "description": "Bombay Point is a scenic viewpoint offering spectacular views of the surrounding hills and valleys. It is a perfect spot to witness sunrise and sunset. The cool and refreshing climate, along with the panoramic vistas, makes it a must-visit destination for travelers seeking natural beauty. Photographers often visit Bombay Point to capture the stunning landscapes."
    },
    {
        "title": "Sahyadri Hills Trekking Trails",
        "description": "Bhimashankar is a popular trekking destination, with multiple trails leading through dense forests, waterfalls, and rocky terrains. The Sahyadri Hills offer trekking experiences suitable for both beginners and experienced trekkers. The monsoon season enhances the beauty of these trails, making them even more scenic and adventurous."
    },
    {
        "title": "Bhorgiri Fort",
        "description": "Bhorgiri Fort is an ancient fort located near Bhimashankar. The fort offers an exciting trek through dense forests and provides stunning views from the top. History enthusiasts visit Bhorgiri Fort to explore its ruins and learn about its historical significance. The trek to the fort is filled with adventure, making it a popular destination among thrill-seekers."
    },
    {
        "title": "Shivneri Fort",
        "description": "Located a little further from Bhimashankar, Shivneri Fort is the birthplace of Chhatrapati Shivaji Maharaj. The fort is a historical treasure and attracts visitors who are interested in Maratha history. The trek to the fort is moderately challenging but rewarding, as it offers magnificent views of the surrounding landscapes."
    }
],

"services": [
  {
    "name": "Pune to Bhimashankar Taxi",
    "description": "S9 Travels offers comfortable and reliable taxi services for your journey from Pune to Bhimashankar. Whether you're visiting for spiritual purposes or leisure, enjoy a smooth and hassle-free ride with us. Book your Pune to Bhimashankar taxi today!"
  },
  {
    "name": "Pune to Bhimashankar Cab Service",
    "description": "Choose S9 Travels for a professional and dependable cab service from Pune to Bhimashankar. Our experienced drivers and well-maintained vehicles guarantee a safe, comfortable, and enjoyable journey."
  },
  {
    "name": "Pune to Bhimashankar One-Way Taxi",
    "description": "S9 Travels offers affordable and convenient one-way taxi services for your journey from Pune to Bhimashankar. Enjoy a direct, comfortable ride without the return trip hassle. Book your one-way taxi today for a stress-free experience."
  },
  {
    "name": "Pune to Bhimashankar Round Trip",
    "description": "For a round trip from Pune to Bhimashankar, S9 Travels provides flexible options. We ensure a comfortable, timely, and stress-free journey with professional drivers and quality vehicles for your round trip."
  },
  {
    "name": "Pune to Bhimashankar Taxi Fare",
    "description": "S9 Travels offers transparent and affordable taxi fares for your Pune to Bhimashankar journey. We ensure that you get great value for your money, with no hidden charges. Contact us for an accurate fare estimate before booking."
  },
  {
    "name": "Pune to Bhimashankar Car Rental",
    "description": "Looking for a car rental for your trip from Pune to Bhimashankar? S9 Travels offers flexible car rental services, allowing you to travel at your own pace. Choose from a variety of vehicles that suit your travel needs."
  },
  {
    "name": "Pune to Bhimashankar Drop Taxi",
    "description": "S9 Travels offers reliable drop taxi services for your journey from Pune to Bhimashankar. Our drop taxi service ensures a direct, comfortable ride to your destination, with a focus on punctuality and convenience."
  },
  {
    "name": "Pune to Bhimashankar Luxury Taxi",
    "description": "For a premium travel experience, S9 Travels offers luxury taxi services from Pune to Bhimashankar. Enjoy extra space, enhanced comfort, and a smooth ride in our luxurious vehicles, making your journey more relaxing and stylish."
  }
],


"tableData": [
  ["Book Pune To Bhimashankar Taxi", "Book Pune To Bhimashankar Cab Service"],
  ["Book Pune To Bhimashankar One-Way Taxi", "Book Pune To Bhimashankar Round Trip"],
  ["Book Pune To Bhimashankar Taxi Fare", "Book Pune To Bhimashankar Car Rental"],
  ["Book Pune To Bhimashankar Drop Taxi", "Book Pune To Bhimashankar Luxury Taxi"]
],
"whychoose": [
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "At S9 Travels, we understand the significance of timely travel when going from Pune to Bhimashankar. Whether it’s for a spiritual visit, a relaxing getaway, or a day trip, we ensure timely pickups and drop-offs, making your journey hassle-free."
  },
  {
    "WhyChooseheading": "Comfortable and Spacious Vehicles",
    "WhyChoosedescription": "Our fleet includes a variety of comfortable and spacious vehicles for your Pune to Bhimashankar trip. All our cars are equipped with air conditioning, comfortable seating, and ample legroom to make your ride smooth and relaxing."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our drivers are experienced and knowledgeable about the best routes to Bhimashankar. With years of experience handling long-distance trips, they ensure a safe, comfortable, and enjoyable journey. They also offer a warm, professional service to enhance your trip."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "S9 Travels provides competitive and transparent pricing for your Pune to Bhimashankar journey. We offer a clear breakdown of costs upfront, ensuring no hidden fees, so you know exactly what to expect."
  },
  {
    "WhyChooseheading": "Safe and Comfortable Journey",
    "WhyChoosedescription": "Your safety is our priority. All our vehicles are equipped with modern safety features such as airbags, seat belts, and GPS tracking, ensuring a secure and comfortable ride from Pune to Bhimashankar."
  },
  {
    "WhyChooseheading": "24/7 Availability",
    "WhyChoosedescription": "S9 Travels operates round-the-clock, so whether you plan an early morning trip or a late-night return, we’re always available. Our customer service team is available to assist you at any time, ensuring that your needs are met at any hour."
  },
  {
    "WhyChooseheading": "Hassle-Free Booking Process",
    "WhyChoosedescription": "Booking your Pune to Bhimashankar cab with S9 Travels is simple and hassle-free. You can book via our website, mobile app, or by contacting our customer service team, who are happy to assist you with personalized support."
  },
  {
    "WhyChooseheading": "Customized Travel Packages",
    "WhyChoosedescription": "We offer customized travel packages tailored to your needs, whether you're visiting Bhimashankar for religious purposes or leisure. Let us know your preferences, and we’ll make sure your trip is comfortable and special."
  }
]















    }



    const faqData = [
        [
          {
            question: 'How can I book a Pune to Bhimashankar cab with S9 Travels?',
            answer: 'Booking is easy! You can book online through our website or app, or contact our customer service team for assistance with your reservation.',
          },
          {
            question: 'Are the drivers experienced for long-distance travel?',
            answer: 'Yes, all our drivers are highly skilled and experienced in long-distance travel. They know the best routes to Bhimashankar and ensure a smooth, safe, and comfortable journey.',
          },
          {
            question: 'What types of vehicles are available for Pune to Bhimashankar travel?',
            answer: 'We offer a variety of vehicles, including sedans, SUVs, and premium cars, all well-maintained for comfort during your journey to Bhimashankar.',
          },
          {
            question: 'How do I pay for my Pune to Bhimashankar cab rental?',
            answer: 'We offer flexible payment options, including cash, credit/debit cards, and online payments via our app, making it convenient for you to pay.',
          },
          {
            question: 'Can I book a round trip from Pune to Bhimashankar?',
            answer: 'Yes, we offer round-trip services. Simply provide your return details, and we’ll make all necessary arrangements for a smooth return journey.',
          },
          {
            question: 'Are there any extra charges for waiting or detours?',
            answer: 'Any additional charges, such as for waiting time or detours, will be communicated upfront, ensuring complete transparency in pricing.',
          },
          {
            question: 'Can I hire a cab for sightseeing in Bhimashankar?',
            answer: 'Yes, we offer sightseeing tours in Bhimashankar, including visits to the famous Bhimashankar Temple and other local attractions. Our experienced drivers will guide you to the best spots.',
          },
          {
            question: 'What is the luggage allowance for a Pune to Bhimashankar cab?',
            answer: 'Our vehicles comfortably accommodate standard luggage. If you have extra luggage or specific requirements, please let us know during the booking process, and we’ll make the necessary arrangements.',
          },
          {
            question: 'Is S9 Travels available for corporate travel between Pune and Bhimashankar?',
            answer: 'Yes, we offer corporate travel services, including business trips or group visits, between Pune and Bhimashankar. We ensure professional, reliable, and punctual service for corporate clients.',
          },
          {
            question: 'Why should I choose S9 Travels for Pune to Bhimashankar travel?',
            answer: 'S9 Travels ensures a comfortable, safe, and affordable journey with professional drivers, well-maintained vehicles, and excellent customer service. You can count on us for a smooth, hassle-free trip every time.',
          },
        ]
      ];
      
      const testimonialsData = [
        {
          name: 'Mr. Rohit Deshmukh',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],  
          text: '“I booked a cab with S9 Travels for a trip to Bhimashankar, and the experience was fantastic. The driver was prompt and professional, and the vehicle was clean and comfortable. I felt safe throughout the trip. Highly recommend them!”',
        },
        {
          name: 'Mrs. Shubhangi Patil',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],  
          text: '“Our family trip to Bhimashankar with S9 Travels was a great experience. The car was spacious and comfortable, and the driver was friendly and knowledgeable. We’ll definitely use their services again!”',
        },
      ];
      
      
      
      
      
      
      
    
    
    
    
    








    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8850328441",
            "+91 9552526916",

        ],
        email: "booking@s9travels.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Book Pune To Nashik Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Book Pune To Ganpatipule Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Book Pune To Ratnagiri Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Book Pune To Devkund Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Book Pune To Goa Cab Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Book Pune To Kolhapur Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Book Pune To Lonavala Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Book Pune To Alibaug Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Book Pune To Aurangabad Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Book Pune To Bhimashankar Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Book Murud Janjira Cab From Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Book Pune To Adlabs Imagica Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Book Pune To Mahabaleshwar Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Book Pune To Trimbakeshwar Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune Mumbai Pune Round Trip",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Mumbai Pune Pickup Drop",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Outstation Cabs From Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service In Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "12 Jyotirlinga Yatra From Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune To Grishneshwar Cab Services",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Pune To Malshej Ghat Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune To Pandharpur Cab Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune To Panhala Fort Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune To Raigad Fort Cab Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune To Satara Kas Pathar Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Pune To Shirdi Cab Pickup Drop",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


    const productSchema = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Book Pune To Bhimashankar Cab",
        "description": "Book Pune To Bhimashankar taxi services, one-way taxi, round trip, luxury taxi, drop taxi, and car rental with S9 Travels. Choose from affordable Pune to Bhimashankar cab booking options for a comfortable and safe journey to Bhimashankar.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.8",
          "ratingCount": "8569"
        }
      };
      
    
      
      
      
      


    return (
        <div>
         

         <Helmet>
        <title>Book Pune To Bhimashankar Cab | Affordable Taxi & Car Rental Services | S9 Travels | Contact: +91 8850328441</title>
        <meta 
          name="description" 
          content="Book Pune To Bhimashankar taxi services, one-way taxi, round trip, luxury taxi, drop taxi, and car rental with S9 Travels. Get the best fares for Pune to Bhimashankar cab booking, ensuring a safe, comfortable, and affordable ride." 
        />
        
        {/* Inject JSON-LD Schema */}
        <script type="application/ld+json">
          {JSON.stringify(productSchema)}
        </script>
      </Helmet>
      
<section className="page-title centred">
      <div className="bg-layer" style={{ backgroundImage: 'url(/images/background/page-title.jpg)' }}></div>
      <div className="auto-container">
        <div className="content-box">
        
          <h1>{cardData.keyword}</h1>
        </div>
      </div>
    </section>

      

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/10.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                  <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For S9 Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                            <FAQKeyword  faqs={faqData} />

                                                {/* <FAQKeyword faqData={faqData} /> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />
                         

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #252E5B',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#252E5B' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918850328441" className="d-block  text-white">+91 8850328441</a>
                                                <a href="tel:+919552526916" className="d-block  text-white">+91 9552526916</a>
                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@s9travels.com" className=" text-white d-block">
                                                    booking@s9travels.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> S9 Travels <br/>
                                                    Khandesh Nagar, Ghandharva Nagri, Moshi,Pune, pin-412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Bookpunetobhimashankarcab;